import { HYDRATE } from 'next-redux-wrapper';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { THydrateAction } from '~/src/store';

import {
    EChangePaymentDateActions,
    IDate,
    TLoadingStatus,
    TSetChangeDate,
    TSetClosePopup,
    TSetCurrentDate,
    TSetIsAutoActivate,
    TSetIsLoading,
    TSetLoadingDayInfoStatus,
    TSetPaySum,
    TSetPopupState,
    TSetSelectedDay,
} from '../actionCreators';

export type TStep = 'confirmation' | 'success' | 'payment' | 'error' | 'none'

export interface IPopupState {
    isOpen: boolean,
    step: TStep,
    title: string,
    text?: React.ReactNode | string | null,
    type?: EResultPopupStatus,
}

export interface IChangePaymentDateState {
    currentDate: IDate,
    selectedDay: number,
    isAutoActivate: boolean,
    isLoading: boolean,
    paySum: number,
    changeDate: string,
    loadingDayInfoStatus: TLoadingStatus,
    popupState: IPopupState,
}

export const initialPopupState: IPopupState = {
    isOpen: false,
    step: 'none',
    title: '',
    text: '',
    type: EResultPopupStatus.DEFAULT,
};

export const initialState: IChangePaymentDateState = {
    currentDate: {
        day: 1,
        month: 1,
    },
    selectedDay: 1,
    isAutoActivate: true,
    isLoading: false,
    paySum: 0,
    changeDate: '',
    loadingDayInfoStatus: 'none',
    popupState: initialPopupState,
};

export type TChangePaymentDateActions =
    | TSetChangeDate
    | TSetCurrentDate
    | TSetClosePopup
    | TSetIsAutoActivate
    | TSetIsLoading
    | TSetLoadingDayInfoStatus
    | TSetPaySum
    | TSetPopupState
    | TSetSelectedDay

const changePaymentDate = (state = initialState, action: TChangePaymentDateActions | THydrateAction): IChangePaymentDateState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state };
        case EChangePaymentDateActions.SET_CURRENT_DATE:
            return {
                ...state,
                currentDate: action.payload,
            };
        case EChangePaymentDateActions.SET_SELECTED_DAY:
            return {
                ...state,
                selectedDay: action.payload,
            };
        case EChangePaymentDateActions.SET_IS_AUTO_ACTIVATE:
            return {
                ...state,
                isAutoActivate: action.payload,
            };
        case EChangePaymentDateActions.SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        case EChangePaymentDateActions.SET_PAY_SUM:
            return {
                ...state,
                paySum: action.payload,
            };
        case EChangePaymentDateActions.SET_CHANGE_DATE:
            return {
                ...state,
                changeDate: action.payload,
            };
        case EChangePaymentDateActions.SET_LOADING_DAY_INFO_STATUS:
            return {
                ...state,
                loadingDayInfoStatus: action.payload,
            };
        case EChangePaymentDateActions.SET_POPUP_STATE:
        case EChangePaymentDateActions.SET_CLOSE_POPUP:
            return {
                ...state,
                popupState: action.payload,
            };
        default:
            return state;
    }
};

export default changePaymentDate;
